import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { branchLocalization } from '../../../features/branchLocalization';
import { getCookie } from '../../../utils/cookies';
import { confirmLocation, PREF_BRANCH_COOKIE } from './BranchLocalizationUtils';
export const BranchLocalizationLayout = (props)=>{
    if (branchLocalization() == 'off') return /*#__PURE__*/ _jsx(_Fragment, {});
    const { branchLocations } = props;
    const preferredBranchId = getCookie(PREF_BRANCH_COOKIE);
    React.useEffect(()=>{
        const select = document.getElementById('lh-location');
        const helperSpan = document.getElementById('helper-span');
        helperSpan.textContent = select.selectedOptions[0].text;
        helperSpan.style.font = window.getComputedStyle(select).font;
        const textWidth = helperSpan.offsetWidth;
        select.style.width = textWidth + 24 + 'px';
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        className: "lh__dropdown",
        children: /*#__PURE__*/ _jsx("div", {
            className: "lh__container container--full gutter--m align--center",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "lh__formwrap",
                children: [
                    /*#__PURE__*/ _jsx("label", {
                        className: "lh__formlabel",
                        htmlFor: "lh-location",
                        children: "Mijn bieb:"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "lh__forminput",
                        children: [
                            /*#__PURE__*/ _jsxs("select", {
                                className: "lh__select",
                                id: "lh-location",
                                value: preferredBranchId,
                                onChange: (e)=>confirmLocation(e.target.value, branchLocations),
                                children: [
                                    /*#__PURE__*/ _jsx("option", {
                                        value: "",
                                        children: preferredBranchId ? 'Geen voorkeur' : 'Selecteren'
                                    }),
                                    branchLocations.map((loc)=>{
                                        return /*#__PURE__*/ _jsx("option", {
                                            value: loc.id,
                                            children: loc.title
                                        }, loc.id);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                id: "helper-span",
                                style: {
                                    position: 'absolute',
                                    visibility: 'hidden',
                                    whiteSpace: 'nowrap'
                                }
                            }),
                            /*#__PURE__*/ _jsx("svg", {
                                className: "lh__icon",
                                "aria-hidden": "true",
                                fill: "none",
                                height: "10",
                                viewBox: "0 0 14 10",
                                width: "14",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ _jsx("path", {
                                    clipRule: "evenodd",
                                    d: "m.324282.989902c.407119-.373192 1.039688-.345689 1.412878.061428l5.26285 5.74129 5.26289-5.74129c.3731-.407117 1.0057-.43462 1.4128-.061428.4071.373188.4347 1.005758.0615 1.412878l-6.00004 6.54546c-.18941.20663-.45685.32428-.73715.32428-.28031 0-.54775-.11765-.73716-.32428l-5.999999-6.54546c-.373192-.40712-.3456886-1.03969.061431-1.412878z",
                                    fill: "#090b09",
                                    fillRule: "evenodd"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
